<div id="paintInfoModal" class="basin-border-radius-10 basin-background-darkest-gray basin-p-3">
    <div *ngIf="interactionType === InteractionType.Paint" class="basin-display-flex basin-flex-column basin-gap-2">
        <p class="basin-color-true-white basin-font-size-16 basin-font-weight-700 basin-line-height-20">
            Paint Agents
        </p>
        <p class="basin-color-true-white basin-font-size-14 ">
            Use the paintbrush tool to add one or more 3 x 3 agents. Each agent is a 5 m x 5 m area.
        </p>
    </div>
    <div *ngIf="interactionType === InteractionType.Drop" class="basin-display-flex basin-flex-column basin-gap-2">
        <p class="basin-color-true-white basin-font-size-16 basin-font-weight-700 basin-line-height-20">
            Drop Agents
        </p>
        <p class="basin-color-true-white basin-font-size-14 ">
            Use the eyedrop tool to add one or more single agents. Each agent is a 5 m x 5 m area.
        </p>
    </div>
</div>
